<template>
  <router-view />
</template>
<script>

export default {
  components: {

  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Barlow:wght@400;700;800;900&display=swap");
#app {
  font-family: "Barlow", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #ffffff;
}
.detail-button {
  display: inline-block;
  position: relative;
  color: #010507;
  text-decoration: none;
}
.detail-button:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 0;
  background-color: #000000;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}
.detail-button:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
</style>
